module.exports = __webpack_public_path__ + "img/plus.b8ecdbe4.svg";